import { useRef as i, useState as T, useEffect as y } from "react";
import { c as m } from "./clamp-CqQfNxSP.js";
function F(c) {
  return {
    x: m(c.x, 0, 1),
    y: m(c.y, 0, 1)
  };
}
function R(c, n, v = "ltr") {
  const d = i(null), u = i(!1), r = i(!1), l = i(0), [x, E] = T(!1);
  return y(() => {
    u.current = !0;
  }, []), y(() => {
    const t = d.current, p = ({ x: e, y: w }) => {
      cancelAnimationFrame(l.current), l.current = requestAnimationFrame(() => {
        if (u.current && t) {
          t.style.userSelect = "none";
          const o = t.getBoundingClientRect();
          if (o.width && o.height) {
            const g = m((e - o.left) / o.width, 0, 1);
            c({
              x: v === "ltr" ? g : 1 - g,
              y: m((w - o.top) / o.height, 0, 1)
            });
          }
        }
      });
    }, h = () => {
      document.addEventListener("mousemove", f), document.addEventListener("mouseup", s), document.addEventListener("touchmove", a), document.addEventListener("touchend", s);
    }, M = () => {
      document.removeEventListener("mousemove", f), document.removeEventListener("mouseup", s), document.removeEventListener("touchmove", a), document.removeEventListener("touchend", s);
    }, b = () => {
      !r.current && u.current && (r.current = !0, typeof (n == null ? void 0 : n.onScrubStart) == "function" && n.onScrubStart(), E(!0), h());
    }, s = () => {
      r.current && u.current && (r.current = !1, E(!1), M(), setTimeout(() => {
        typeof (n == null ? void 0 : n.onScrubEnd) == "function" && n.onScrubEnd();
      }, 0));
    }, S = (e) => {
      b(), e.preventDefault(), f(e);
    }, f = (e) => p({ x: e.clientX, y: e.clientY }), L = (e) => {
      e.cancelable && e.preventDefault(), b(), a(e);
    }, a = (e) => {
      e.cancelable && e.preventDefault(), p({ x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY });
    };
    return t == null || t.addEventListener("mousedown", S), t == null || t.addEventListener("touchstart", L, { passive: !1 }), () => {
      t && (t.removeEventListener("mousedown", S), t.removeEventListener("touchstart", L));
    };
  }, [v, c]), { ref: d, active: x };
}
export {
  F as c,
  R as u
};
